import { Input, Radio, Space, Switch } from "antd";

const Attribute = ({ object, onChange, showUidRadio }) => {
  return (
    <Space align="center" direction="vertical">
      <Switch
        defaultChecked={object.relevant}
        onChange={(checked) => onChange({ relevant: checked })}
      />
      <Switch
        defaultChecked={object.fuzziness}
        onChange={(checked) => onChange({ fuzziness: checked })}
      />
      {showUidRadio && <Radio checked={object.uid} disabled={true} />}
      <Input
        defaultValue={object.name}
        styles={{ justifyContent: "center" }}
        onChange={(target) => onChange({ name: target.currentTarget.value })}
      />
      <Input.TextArea
        defaultValue={object.phrase}
        styles={{ justifyContent: "center" }}
        autoSize={{ minRows: 5, maxRows: 5 }}
        onChange={(target) => onChange({ phrase: target.currentTarget.value })}
      />
    </Space>
  );
};

export default Attribute;
